module.exports = __webpack_public_path__ + "static/media/wa-background-light.adbccee0.png";